<template>
  <div>
    <div class="page-bg page">
      <div class="header">
        <div class="header-title">数字藏品</div>
      </div>
      
      <div class="header-seach">
        <div class="seach-box">
          <input
            type="text"
            class="seach-input"
            placeholder="请输入搜索关键词"
            v-model="keywords"
          />
          <div
            class="seach-icon"
            @click="
              $router.push('/goods?keywords=' + encodeURIComponent(keywords))
            "
          ></div>
        </div>
      </div>

      <div class="page-content">
        <div ref="scroll-classify" class="classify-wrap">
          <div>

            
            <el-empty v-if="loading" style="padding:0;" :image="require('@/assets/images/common/icon-loading.png')" description="加载中，请稍后"></el-empty>
            <div class="index-swiper">
              <div class="wrap">
                <div class="swiper-banner-container" ref="swiper-banner-container">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="(item, index) in bannerList"
                      :key="index"
                    >

                      <a :href="item.link_url" v-if="item.link_url && item.link_url !=='#'">
                        <div class="img">
                          <img :src="item.image_url" alt="" />
                        </div>
                      </a>
                      <router-link :to="{ path: '/news/' + item.slide_id }" v-else-if="item.content">
                        <div class="img">
                          <img :src="item.image_url" alt="" />
                        </div>
                      </router-link>
                      <div class="img" v-else>
                        <img :src="item.image_url" alt="" />
                      </div>
                      
                    </div>
                  </div>
                  <div class="swiper-pagination" ref="swiper-banner-pagination"></div>
                </div>
              </div>
            </div>
            <div class="index-goods">
              <div class="index-title">版权品</div>
              <el-empty v-if="loading" style="padding:0;" :image="require('@/assets/images/common/icon-loading.png')" description="加载中，请稍后"></el-empty>

              <div class="goods-list">
                <div class="goods-list-wrap">
                  <div
                    class="item"
                    v-for="(item, index) in goodList"
                    :key="index"
                  >
                    <router-link
                      :to="{ path: '/goods/details?id=' + item.slide_id }"
                    >
                      <div class="item-goods-box">
                        <div class="item-img">
                          <!-- <div class="preview-img" :style="{ backgroundImage: 'url('+item.avatarimg+')' }"></div> -->
                          <div
                            class="preview-img"
                            v-lazy:background-image="item.avatarimg"
                          ></div>
                          <div
                            class="item-state"
                            :class="'state-' + item.status"
                          >
                            <span>{{
                              Number(item.status) === 1
                                ? "热卖中"
                                : Number(item.status) === 2
                                ? "已售罄"
                                : "敬请期待"
                            }}</span>
                          </div>
                          <div class="item-collection">
                            <div class="icon"></div>
                            <div class="text">{{ item.collection_num }}</div>
                          </div>
                          <div
                            class="item-label"
                            v-if="Number(item.parent) === 0"
                          >
                            版
                          </div>
                          <div class="item-limit">
                            <div class="text">
                              限购:
                              <span>{{ item.num + " / " + item.all_num }}</span>
                            </div>
                          </div>
                        </div>
                        <div class="item-info">
                          <div class="info-fl">
                            <div class="title">{{ item.title }}</div>
                            <div class="author">{{ item.author }}</div>
                          </div>
                          <div class="info-fr">
                            <div class="price">
                              ￥{{ item.price | formatMoney }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import Swiper from "../../../assets/js/libs/swiper.min";

import { Lazyload, Toast } from "vant";
import { Skeleton } from 'vant';

Vue.use(Skeleton);

import {  Empty } from "element-ui";

Vue.use(Empty);




// const loadingImg = require('@/assets/images/common/img-loading.png');
Vue.use(Lazyload, {
  lazyComponent: true,
});
export default {
  name: "index",
  data() {
    return {
      keywords: "不良人",
      loading:true,
    };
  },

  created() {
    // let toastLoading = Toast.loading({
    //   duration: 0, // 持续展示 toast
    //   forbidClick: true,
    //   message: "正在加载...",
    // });
    let that = this;

    this.getIndex({
      success: (res) => {

        // toastLoading.clear();

        if (res.status == 1) {

          that.loading = false;
          
          this.$nextTick(() => {
            
            // this.myScroll.refresh();
            that.swiperBannerFun();

          });

        }
      },
    });
  },
  computed: {
    ...mapState({
      bannerList: (state) => state.index.bannerList,
      goodList: (state) => state.index.goodList,
    }),
  },
  methods: {
    /**
     * 1.先在api中创建接口
     * 2.在store中创建主目录
     * 3.用actions读取接口 - 》在页面import导入Vuex，mapActions
     * 4. ...mapActions({getBanner:"index/getBanner"})导入到页面中
     * 5.在created中调用  this.getBanner();
     * 6.
     *
     *
     */
    ...mapActions({
      getIndex: "index/getIndex",
    }),

    //    scrollPreventDefault(e){
    //        e.preventDefault();
    //    },

    swiperBannerFun(){
      let that = this;    
      that.swiperBanner = new Swiper(this.$refs["swiper-banner-container"], {
        init: true,
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        initialSlide: 0,
        loop: true, // 循环模式选项
				observer: true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: true,//修改swiper父元素时，自动初始化swiper
				observeSlideChildren: true,
        
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: this.$refs["swiper-banner-pagination"],
          clickable: true,
        },
        resizeObserver: true,
      });
      that.$nextTick(() => {
				that.swiperBanner.update();
			})

    },


  },
  mounted() {
    // this.$refs['scroll-classify'].addEventListener("touchmove",this.scrollPreventDefault);
    // this.myScroll=new IScroll(this.$refs['scroll-classify'], {
    //     scrollX : false,
    //     scrollY : true,
    //     preventDefault : false
    // });
    
    // let that = this;
    // window.addEventListener('resize',()=>{
    //   // console.log(2);      
    //   that.$nextTick(() => {
	  //     that.swiperBanner.update();
    //     console.log(that.swiperBanner);        
    //   });
    // })


  },
  beforeDestroy() {
    // this.$refs['scroll-classify'].removeEventListener("touchmove",this.scrollPreventDefault);
  },
};
</script>


<style scoped lang="scss">
@import "../../../assets/css/common/swiper.min.css";

.page {
  width: 100%;
  background-size: cover;
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
  background-position:top center;

}
.wrap {
  padding: 0 0.45rem;
  box-sizing: border-box;
}


.header-title {
  font-size: 0.34rem;
  font-weight: bold;
  color: #333234;
  padding: 0.3rem 0 0.26rem;
  text-align: center;
}
.header-seach {
  text-align: center;
  .seach-box {
    width: 4.48rem;
    height: 0.55rem;
    margin: 0 auto;
    position: relative;
    .seach-input {
      width: 4.48rem;
      height: 0.55rem;
      background: url("../../../assets/images/common/search-bg.png") no-repeat
        center;
      background-size: 100%;
      text-align: center;
      font-size: 0.26rem;
      color: #2c2827;
    }
    .seach-icon {
      position: absolute;
      right: 0.12rem;
      top: 0;
      width: 0.55rem;
      height: 0.55rem;
      background: url("../../../assets/images/common/search.png") no-repeat
        center;
      background-size: 0.29rem;
    }
  }
}

.page-content {
  position: absolute;
  top: 1.8rem;
  bottom: 1.2rem;
  left: 0;
  width: 100%;
}
.classify-wrap {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling : touch;
}

.index-swiper {
  overflow: hidden;
  padding: 0.05rem 0 0.1rem;
  width: 100%;
  .wrap {
    padding: 0 0.38rem;
  }

  .swiper-slide {
    padding: 0 0.05rem;
    box-sizing: border-box;
  }
  .img {
    border-radius: 0.18rem;
    box-shadow: 0.877px 1.798px 4px 0px rgba(0, 0, 0, 0.73);
    overflow: hidden;
    img {
      width: 100%;
      height: 2.31rem;
    }
  }

  .swiper-pagination {
    bottom: 0.1rem;
    width: 100%;
  }

  .swiper-banner-container {
    position: relative;
    width: 100%;
  }
}

.index-title {
  font-size: 0.3rem;
  font-weight: bold;
  color: #333234;
  text-align: center;
  line-height: 0.49rem;
  background: url("../../../assets/images/common/tit-bg.png") no-repeat center;
  background-size: auto 100%;
}

.index-goods {
  margin-top: 0.58rem;
  box-sizing: border-box;
  overflow: hidden;
}

@import "../../../assets/css/goods/goodList.scss";

.goods-list {
  margin-top: 0.25rem;
  box-sizing: border-box;

  .goods-list-wrap {
    padding: 0 0.45rem;
  }
}
</style>

<style lang="scss">
.swiper-pagination {
  .swiper-pagination-bullet {
    width: 0.26rem;
    height: 0.26rem;
    background: url("../../../assets/images/home/index/btn1.png") no-repeat
      center;
    background-size: auto 0.19rem;
    opacity: 0.6;
    margin: 0 0.08rem;
  }
  .swiper-pagination-bullet-active {
    background: url("../../../assets/images/home/index/btn1-on.png") no-repeat
      center;
    background-size: auto 100%;
    opacity: 1;
  }
}
</style>
